import React, { ReactElement } from 'react';
import { Text } from 'rsuite';
import { BucketGroup } from '../BucketGroup';
import {
  BucketData,
  PeriodAndLicense,
  TaxPeriodError,
  TaxReportLicense,
} from 'src/types/tax';

interface RevenuePeriodProps extends PeriodAndLicense {
  buckets: Array<BucketData>;
  error?: TaxPeriodError;
  isMobile?: boolean;
  name: string;
  value: Array<TaxReportLicense>;
}

export const RevenuePeriod = ({
  buckets,
  error,
  isMobile,
  label,
  licenses,
  name,
  value,
}: RevenuePeriodProps): ReactElement => {
  return (
    <>
      <Text
        as="h3"
        style={{ padding: '16px 0 ' }}
      >
        {label}
      </Text>
      {licenses.map((license, index) => {
        return (
          <BucketGroup
            buckets={buckets}
            error={error?.licenses?.[index]}
            key={`${name}.licenses[${index}]`}
            name={`${name}.licenses[${index}]`}
            title={license.address}
            values={value[index]}
            isMobile={isMobile}
          />
        );
      })}
    </>
  );
};
